import { Component } from '@angular/core';
import { marker as _ } from '@biesbjerg/ngx-translate-extract-marker';
import { TranslatePipe } from '@ngx-translate/core';
import { HeaderBarComponent } from '@nimmsta/ng-commons-lib/header-bar';
import { Tab, TabList, TabPanel, TabPanels, Tabs } from 'primeng/tabs';
import { EmailFormComponent } from './email-form.component';
import { environment } from '../../../environments/environment';

_('support.title');

@Component({
  selector: 'app-support',
  templateUrl: './support.component.html',
  styleUrls: ['./support.component.scss'],
  imports: [
    Tabs,
    TabList,
    Tab,
    TabPanels,
    TabPanel,
    TranslatePipe,
    HeaderBarComponent,
    EmailFormComponent,
  ],
})
export class SupportComponent {
  activeTab = 'docs';
  private lastTab = 'docs';

  protected readonly environment = environment;

  onTabChange(value: string | number | undefined): void {
    if (typeof value !== 'string') {
      return;
    }
    if (value === 'ticket') {
      window.open(
        'https://nimmsta.atlassian.net/servicedesk/customer/portals',
        '_blank',
      );
      this.activeTab = this.lastTab;
      return;
    }
    this.activeTab = value;
    this.lastTab = value;
  }
}
